import classnames from 'classnames'
import styles from './HomeProductListTransitionBoxes.module.scss'
import gsap from 'gsap'
import { Flip } from 'gsap/dist/Flip'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import SanityImage from '@/components/SanityImage/SanityImage'

gsap.registerPlugin(Flip)

const DEBUG = false
const COUNT = 8

export const TRANSITION_MAP = {
  1: 27,
  2: 32,
  3: 16,
  4: 17,
  5: 33,
  6: 26,
  7: 31,
  8: 15,
}

const HomeProductListTransitionBoxes = forwardRef(({ className }, ref) => {
  const $boxes = useRef({})
  const $boxPositions = useRef({})
  const $container = useRef()
  const [render, setRender] = useState(true)
  const [imageAssetsByIndex, setImageAssetsByIndex] = useState({})

  const visuallyHide = () => {
    gsap.set($container.current, {
      opacity: 0,
    })
  }

  const disallowHover = () => {
    gsap.set($container.current, {
      pointerEvents: 'none',
    })
  }

  const hide = () => {
    gsap.to($container.current, {
      autoAlpha: 0,
      duration: 0.1,
      onComplete: () => {
        setRender(false)
      },
    })
  }

  const fetchImageAssets = () => {
    const imageAssets = {}
    document.querySelectorAll('[data-image-asset]').forEach($el => {
      if (!$el) return
      const imageAsset = JSON.parse($el.dataset.imageAsset)
      if (!imageAsset) return

      Object.values(TRANSITION_MAP).forEach((value, i) => {
        if (value === parseInt($el.dataset.boxIndex)) {
          const key = i
          imageAssets[key] = imageAsset
        }
      })
    })
    setImageAssetsByIndex(imageAssets)
  }

  useEffect(() => {
    fetchImageAssets()
  }, [])

  useImperativeHandle(ref, () => ({
    hide,
    setRender,
    visuallyHide,
    disallowHover,
  }))

  if (!render) return null

  return (
    <div
      className={classnames(styles.HomeProductListTransitionBoxes, className, { [styles.debug]: DEBUG })}
      ref={$container}
    >
      {Array(COUNT)
        .fill(null)
        .map((_, i) => (
          <div
            key={i}
            className={styles.box}
            data-box={i + 1}
            data-is-top={`${i === 0}`}
            id={`transitionBox${i + 1}`}
            ref={ref => {
              $boxes.current[i] = ref
            }}
            data-debug-index={i}
            data-image-asset-exists={Boolean(imageAssetsByIndex[i])}
            data-tied-to-index={TRANSITION_MAP[i + 1]}
          >
            <div className={styles.box__inner}>
              {imageAssetsByIndex[i] && (
                <SanityImage
                  image={imageAssetsByIndex[i]}
                  className={styles.box__image}
                  breakpoints={{
                    xs: {
                      width: 100,
                    },
                    tablet: {
                      width: 300,
                    },
                    laptop: {
                      width: 500,
                    },
                  }}
                />
              )}
              {DEBUG && <span className={styles.box__debugText}>{i + 1}</span>}
            </div>
          </div>
        ))}
      {Array(COUNT)
        .fill(null)
        .map((_, i) => (
          <div
            key={i}
            className={styles.boxPosition}
            data-box={i + 1}
            ref={ref => {
              $boxPositions.current[i] = ref
            }}
          >
            {DEBUG && <span className={styles.box__debugText}>{i + 1}</span>}
          </div>
        ))}
    </div>
  )
})

HomeProductListTransitionBoxes.displayName = 'HomeProductListTransitionBoxes'

export default HomeProductListTransitionBoxes
